import { alpha, Box, styled, Text } from '@ltvco/refresh-lib/theme';
import { ChevronRight } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export const MOBILE_CARD_RADIUS_PX = 20;

export const ExploreByProductLayout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 0,
  alignItems: 'stretch',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: MOBILE_CARD_RADIUS_PX,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'minmax(0, 1.22fr) minmax(260px, 1fr)',
    gap: theme.spacing(3.5),
    alignItems: 'start',
    border: 'none',
    borderRadius: 0,
    overflow: 'visible',
    backgroundColor: 'transparent',
  },
}));

export const ExploreByProductCategoryStack = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '& + &': {
      marginTop: theme.spacing(3),
    },
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(7.5),
    paddingBottom: theme.spacing(7.5),
    '& + &': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  },
}));

export const SectionTitle = styled(Text)(() => ({
  fontFamily: 'lato',
  fontWeight: 700,
  display: 'inline-block',
  pb: 0.375,
  mb: 2.25,
})) as typeof Text;

export const Intro = styled(Text)(({ theme }) => ({
  mb: 3.5,
  maxWidth: 540,
  lineHeight: 1.65,
  [theme.breakpoints.down('md')]: {
    maxWidth: 'none',
  },
})) as typeof Text;

export const LinkDivider = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  my: 0,
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
  },
}));

export const LinkBody = styled(Box)(() => ({
  minWidth: 0,
  pt: 0.125,
}));

export const LinkTitle = styled(Text)(() => ({
  fontWeight: 700,
  display: 'block',
  mb: 0.625,
  lineHeight: 1.35,
})) as typeof Text;

export const LinkDescription = styled(Text)(() => ({
  display: 'block',
  lineHeight: 1.55,
})) as typeof Text;

export const RowChevron = styled(ChevronRight)(({ theme }) => ({
  fontSize: 22,
  color: theme.palette.primary.main,
  justifySelf: 'end',
  mt: 0.875,
}));

export const GraphicWrap = styled(Box)(({ theme }) => ({
  minWidth: 0,
  alignSelf: 'stretch',
  display: 'block',
  lineHeight: 0,
  order: -1,
  borderTopLeftRadius: MOBILE_CARD_RADIUS_PX,
  borderTopRightRadius: MOBILE_CARD_RADIUS_PX,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  overflow: 'hidden',
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  [theme.breakpoints.up('md')]: {
    order: 0,
    alignSelf: 'start',
    marginLeft: theme.spacing(6.25),
    backgroundColor: 'transparent',
    lineHeight: 'normal',
    borderRadius: 0,
    overflow: 'visible',
  },
}));

export const ProductRowLink = styled(RouterLink)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${theme.spacing(6)} minmax(0, 1fr) ${theme.spacing(
    3.5
  )}`,
  columnGap: theme.spacing(2),
  alignItems: 'start',
  paddingTop: theme.spacing(2.25),
  paddingBottom: theme.spacing(2.25),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  marginLeft: 0,
  marginRight: 0,
  borderRadius: theme.shape.borderRadius,
  textDecoration: 'none',
  color: 'inherit',
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.shortest,
  }),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    marginLeft: theme.spacing(-0.5),
    marginRight: theme.spacing(-0.5),
  },
}));
